import { defineComponent as _defineComponent } from 'vue'
import AvailableExaminationsComponent from "../../components/available-examinations-component.vue";
import BreadCrumbComponent from "@/components/bread-crumb-component.vue";
import ExaminationPermitsComponent from "../../components/examinations/examination-permits.vue";
import ExamRatingDialog from "../../components/dialogs/exam-rating-dialog.vue";
import { onMounted, ref } from "vue";
import { useRoute } from "vue-router/composables";


export default /*#__PURE__*/_defineComponent({
  __name: 'examinations',
  setup(__props) {

const route = useRoute();

const submittedExaminationId = ref("");
const openExamRatingDialog = ref(false);
const showExamPermitsDialog = ref(false);

const showExamRatingDialog = () => {
  openExamRatingDialog.value = true;
};
const closeExamRatingDialog = () => {
  openExamRatingDialog.value = false;
};
const showExamPermitDialog = () => {
  showExamPermitsDialog.value = true;
};
const closeExamPermitDialog = () => {
  showExamPermitsDialog.value = false;
};

onMounted(() => {
  if (route.params.submitted_examination_id) {
    submittedExaminationId.value = route.params.submitted_examination_id;
  }

  if (route.params.should_ask_for_feedback) {
    showExamRatingDialog();
  }
});

return { __sfc: true,route, submittedExaminationId, openExamRatingDialog, showExamPermitsDialog, showExamRatingDialog, closeExamRatingDialog, showExamPermitDialog, closeExamPermitDialog, AvailableExaminationsComponent, BreadCrumbComponent, ExaminationPermitsComponent, ExamRatingDialog }
}

})